import React from 'react';

import Typography from '@material-ui/core/Typography';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

export default class ParamTableCard extends React.Component {

  render(){

    return (
      <Paper className={this.props.style}>
        <Typography variant="h6" gutterBottom style={{display: 'inline-block'}}>
          {this.props.type[0].toUpperCase() + this.props.type.substring(1)} Parameters
        </Typography>
        <TableContainer >
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell>Key</TableCell>
                <TableCell align="left">Value</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.props.data.map((val, key) => (
                <TableRow key={key}>
                  <TableCell component="th" scope="row">{val.key}</TableCell>
                  <TableCell align="left">{val.value}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    );
  }
}
